import React, { useEffect, useState } from "react";

const classNames = (...className) => className.filter(Boolean).join(" ");

const ScrollToTop = () => {
  const [isShown, setIsShown] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const scrollToTop = () => {
    document.documentElement.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const onScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    const estimatedFooterHeight = 150;
    const showScrollButtonThreshold = 100;
    const bottomThreshold = scrollHeight - clientHeight - estimatedFooterHeight;

    if (scrollTop > showScrollButtonThreshold) setIsShown(true);
    else setIsShown(false);

    if (scrollTop > bottomThreshold) setIsAtBottom(true);
    else setIsAtBottom(false);
  };

  useEffect(() => {
    document.addEventListener("scroll", onScroll);
    return () => document.removeEventListener("scroll", onScroll);
  }, []);

  if (!isShown) return null;

  return (
    <div className="w-full bottom-0 pointer-events-none fixed">
      <div className="container mx-auto relative">
        <button
          type="button"
          className={classNames(
            "text-primary p-3 pointer-events-auto shadow rounded-xl absolute right-8 bg-white hover:shadow-lg transition-all cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary",
            isAtBottom ? "bottom-32" : "bottom-8"
          )}
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="fa fa-chevron-up" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  );
};

export default ScrollToTop;
